import { IDataSettingState } from '@/redux/slice/settings.slice';

export const appCss = `
.ot-estimated-shipping-basic-layout {
  padding: 15px;
  padding-left: 0;
}

.ot-estimated-shipping-zipcode-input {
  padding: 8px;
  border: 1px solid rgba(119, 119, 119, 1);
  border-radius: 8px;
  min-width: 0;
}

.ot-estimated-shipping-zipcode-input:focus-visible {
  outline: -webkit-focus-ring-color auto 1px;
  outline-offset: 0px;
  box-shadow: none;
}

.ot-estimated-shipping-country-select-box {
  margin-top: 8px;
  margin-bottom: 8px;
}

.ot-estimated-shipping-country-select-box-country,
.ot-estimated-shipping-country-select-box-province {
  width: 49%;
  padding: 8px;
  border: 1px solid #ccc;
  border-radius: 8px;
  color: #000 !important;
  appearance: none;
  background: url(https://api.iconify.design/akar-icons/chevron-down.svg) no-repeat center / contain;
  background-size: 15px;
  background-position: calc(100% - 8px);
  background-color: #fff;
}

.ot-estimated-shipping-country-select-box-country.ot-estimated-shipping-country-select-box-country-max-width {
  width:100%;
}

.ot-estimated-shipping-country-select-box-country:hover,
.ot-estimated-shipping-country-select-box-province:hover {
  background-color: #f5f5f5;
  cursor: pointer;
}

.ot-estimated-shipping-country-select-box-country:focus-visible,
.ot-estimated-shipping-country-select-box-province:focus-visible {
  outline: none;
  outline-offset: 0;
  box-shadow: none;
}

.ot-estimated-shipping-timeline-layout {
  margin-top: 10px;
}

.ot-estimated-shipping .timeline-layout {
  display: inline-flex;
  width: 100%;
  padding: 15px 10px 15px 10px;
  border-radius: 8px;
}

.ot-estimated-shipping .timeline-layout--item:nth-child(1) {
  align-items: center;
}

.ot-estimated-shipping .timeline-layout--item:nth-child(3) {
  align-items: center;
}

.ot-estimated-shipping .timeline-layout--item {
  display: flex;
  flex-direction: column;
  align-items: center;
  /* float: left; */
  position: relative;
  list-style: none;
  text-align: center;
}

.ot-estimated-shipping .timeline-layout--item .timeline-layout--item--wrapper {
  display: flex;
  align-items: center;
  flex-direction: column;
}

.ot-estimated-shipping .timeline-layout--item.with-connect-line::after {
  content: '';
  position: absolute;
  top: 14px;
  height: 2.4px;
  z-index: 0;
  margin-top: 10px;
  width: 100%;
}

.ot-estimated-shipping .timeline-layout--item.two-item.with-connect-line:last-child::after {
  background-image: none
}

.ot-estimated-shipping .timeline-layout--item:nth-child(1):after {
  left: calc(50%);
}

.ot-estimated-shipping .timeline-layout--item:nth-child(2):after {
  left: calc(50%);
}

.timeline-layout--item:nth-child(1) .timeline-layout--item--wrapper {
  align-items: center;
  text-align: center;
}

.timeline-layout--item:nth-child(3) .timeline-layout--item--wrapper {
  align-items: center;
  text-align: center;
}

.timeline-layout--item:nth-child(1) .timeline-layout--text {
  text-align: center;
}

.timeline-layout--item:nth-child(3) .timeline-layout--text {
  text-align: center;
}

.timeline-layout--svg {
  box-shadow: 0px 0px 10px 1px rgba(0, 0, 0, 0.1);
  color: #fff;
  width: 44px;
  height: 44px;
  display: flex;
  z-index: 1;
  align-items: center;
  border-radius: 50%;
  justify-content: center;
  background-color: #fff;
}

.timeline-layout--svg .timeline-layout--svg--icon {
  z-index: 2;
  color: rgb(0, 0, 0);
  fill: currentColor;
  display: inline-block;
  font-size: 2.5rem;
  transition: fill 0.2s cubic-bezier(0.4, 0, 0.2, 1) 0s;
  flex-shrink: 0;
  user-select: none;
  stroke: unset;
}

.ot-estimated-shipping-shipping-methods {
  margin-top: 0.5rem;
}

select.ot-estimated-shipping-shipping-methods-select-box {
  width: 100%;
  padding: 8px;
  border-radius: 8px;
  font-family: inherit;
  appearance: none;
	background: url(https://api.iconify.design/akar-icons/chevron-down.svg) no-repeat center / contain;
	background-size: 15px;
	background-position: calc(100% - 8px);
  background-color: #fff;
}

.dot-underline {
  border-bottom: 1px dotted black;
}

.timeline-layout--title:hover .timeline-layout--description {
  visibility: visible !important;
}

.timeline-layout--title {
  position: relative;
}

.last-description:before {
  left: unset !important;
  right: 5px;
}

.last-description {
  margin-left: -155px;
}

.timeline-layout--item:nth-child(2) .timeline-layout--description::before {
  right: 50%;
  left: unset !important;
}

.timeline-layout--item:nth-child(2) .timeline-layout--description {
  margin-left: -68px !important;
}

.timeline-layout--description {
  visibility: hidden;
  width: 200px;
  text-align: justify;
  border-radius: 6px;
  padding: 7px;
  position: absolute;
  z-index: 100;
  top: 100%;
  left: 0;
  margin-top: 10px;
  box-shadow: 0 0 3px rgba(56, 54, 54, 0.86);
  font-weight: 400;
}

.timeline-layout--title .timeline-layout--description:before {
  content: '';
  position: absolute;
  bottom: 100%;
  left: 10px;
  border-left: 10px solid transparent;
  border-right: 10px solid transparent;
  border-bottom: 10px solid rgb(200 200 200 / 85%);
  border-top: 10px solid transparent;
}

.ot-hide {
  display: none;
}

.ot-estimated-shipping-country-show-select-box-btn {
  cursor: pointer;
}

.ot-estimated-shipping-basic-shipping-privacy-text {
  display: flex !important;
  flex-direction: column;
}
`;

export const estimatedShippingCss = `
.ot-estimated-shipping {
  overflow-wrap: break-word;
  word-break: break-word;
}
.ot-estimated-shipping p {
  margin: 0;
}
.ot-estimated-shipping-basic-shipping-privacy {
  display: flex;
  flex-direction: column;
}
.ot-estimated-shipping-basic-shipping-privacy p {
  margin: 0;
}
.product-estimated-shipping-detail {
  position: relative;
}
.ot-estimated-shipping [class$='shipping-privacy'] {
  position: relative;
}
.ot-estimated-shipping [class$='shipping-privacy'] p {
  display: inline-block;
}
.ot-estimated-shipping [class$='shipping-privacy'] .shipping-privacy-href {
  color: #ab47bc;
  &:hover + [class$='shipping-privacy-more'] [class$='shipping-privacy-more-popup'] {
      opacity: 1;
      visibility: visible;
    }
}
.ot-estimated-shipping [class$='shipping-privacy'] .shipping-privacy-href::after {
  content: none;
}
.ot-estimated-shipping [class$='shipping-privacy-more'] {
  display: inline-block;
  text-align: center;
  border-radius: 100%;
  cursor: pointer;
  position: relative;
  margin-left: 4px;
}
.ot-estimated-shipping [class$='shipping-privacy-more'] i.fa {
  padding-left: 2px;
  font-size: 10px;
}
.ot-estimated-shipping [class$='shipping-privacy-more-popup'] {
  opacity: 0;
  position: absolute;
  left: 4px;
  bottom: -4px;
  min-width: 200px;
  background: #fff;
  text-align: left;
  padding: 8px;
  z-index: 1;
  border: 1px solid #c0c4cc;
  border-radius: 6px;
  box-shadow: 0 0 2px 2px rgba(0, 0, 0, 0.01);
  transition: opacity 0.2s;
  visibility: hidden;
}
.ot-estimated-shipping [class$='shipping-privacy-more-popup']::after {
  content: '';
  position: absolute;
  bottom: 3px;
  left: 0;
  margin-left: -10px;
  border-width: 5px;
  border-style: solid;
  border-color: transparent #c0c4cc transparent transparent;
}
.ot-estimated-shipping .flag-icon {
  background-size: contain;
  background-position: 50%;
  background-repeat: no-repeat;
  position: relative;
  display: inline-block;
  width: 1.33333333em;
  line-height: 1em;
}
.ot-estimated-shipping .flag-icon.flag-icon-squared {
  width: 1em;
}
.ot-estimated-shipping .flag-icon:before {
  content: '\x00a0';
}
.ot-estimated-shipping-item-shipping-method {
  margin-bottom: 10px;
  border-radius: 8px;
  padding: 5px;
  transition: transform 0.2s;
  display: flex;
  position: relative;
  padding-left: 1rem;
  align-items: center;
}
.ot-estimated-shipping-item-shipping-method > div > label {
  display: flex;
  align-items: center;
  margin-right: 5px;
  margin-bottom: 0;
}
.ot-estimated-shipping-item-shipping-method > div {
  margin-left: 0;
}
.ot-estimated-shipping-text-shipping {
  display: inline;
}
.ot-estimated-shipping-text-countdown {
  display: inline;
}
.ot-estimated-shipping-item-shipping-method.ot-estimated-shipping-item-shipping-method-hide-radio {
  padding-left: 10px;
}
.ot-estimated-shipping-item-shipping-method > input {
  position: absolute;
  width: 20px;
  height: 20px;
  margin-top: 1.7%;
}
.ot-estimated-shipping-item-shipping-method > input[type='radio'] {
  visibility: hidden;
}
.ot-estimated-shipping-item-shipping-method:hover {
  cursor: pointer;
}
.ot-estimated-shipping-title-shipping {
  font-weight: 600;
}
.ot-estimated-shipping-item-radio {
  display: none;
}
.ot-estimated-shipping-item-radio + label:before {
  content: '';
  display: inline-block;
  width: 15px;
  height: 15px;
  padding: 3px;
  margin-right: 5px;
  background-clip: content-box;
  border: 1px solid #bbb;
  background-color: #ffffff;
  border-radius: 50%;
}
.ot-estimated-shipping *,
.ot-estimated-shipping :after,
.ot-estimated-shipping :before {
  box-sizing: border-box;
}
.ot-estimated-shipping-timeline-range {
  display: flex;
  flex-direction: column;
  text-align: center;
}
.ot-estimated-shipping-timeline-range.horizontal{
  flex-direction: row;
}

.ot-estimated-shipping-timeline-range.horizontal .ot-estimated-shipping-timeline-range-shipped-down,
.ot-estimated-shipping-timeline-range.horizontal .ot-estimated-shipping-timeline-range-delivery-down {
  padding-left: 4px;
  padding-right: 4px;
}

.ot-estimated-shipping-timeline-range.vertical .ot-estimated-shipping-timeline-range-shipped-down,
.ot-estimated-shipping-timeline-range.vertical .ot-estimated-shipping-timeline-range-delivery-down{
  rotate: 90deg;
}
.ot-estimated-shipping-shipping-methods-select-box {
  color: #000 !important;
}
option.ot-estimated-shipping-item-shipping-method {
  color: #000 !important;
}
.ot-estimated-shipping > div {
  overflow: hidden;
}
.ot-estimated-shipping > div:last-child {
  overflow: visible;
}
.ot-estimated-shipping-zipcode-submit-btn-input-form {
  display: flex;
  margin-bottom: 6px;
}
.ot-estimated-shipping-zipcode-submit-btn-title {
  margin-bottom: 8px;
}
.ot-estimated-shipping-zipcode-submit-btn {
  cursor: pointer;
  padding: 8px;
  border-radius: 8px;
  border: none;
  display: inline;
}
.ot-estimated-shipping-mt-8 {
  margin-top: 1rem;
}
p {
  margin-top: 0px;
  margin-bottom: 0px;
}
.ot-estimated-shipping-icon-shipping {
  margin-left: 4px;
}
.ot-estimated-shipping-tabs {
  margin-bottom: 0.5rem;
  display: flex;
  gap: 0.25rem;
}
.ot-estimated-shipping-tab {
  cursor: pointer;
  border: none;
  border-radius: 0.5rem;
  padding: 6px 12px;
  flex: 1;
}
`;

export const mainControllerCss = (generalSetting: IDataSettingState) => `
                [class="ot-estimated-shipping"] {
                    font-size : ${generalSetting.text_size}px;
                    color     : ${generalSetting.text_color};
                    line-height: ${generalSetting.text_size * 1.5}px;
                }
                [class^="ot-estimated-shipping-country-courier"] > a {
                    font-size : ${generalSetting.text_size}px;
                    color     : ${generalSetting.text_color};
                }
                [class^="ot-estimated-shipping-zipcode-layout"] > p {
                    font-size : ${generalSetting.text_size}px;
                    color     : ${generalSetting.text_color};
                }
                [class^="ot-estimated-shipping-privacy-text"] > a:hover {
                    font-size : ${generalSetting.text_size}px;
                    color     : ${generalSetting.text_color};
                }
                [class^="ot-estimated-shipping-basic-layout"] {
                    border :2px solid ${generalSetting.border_color};
                    border-radius: 8px;
                    background-color :  ${generalSetting.background_color};
                    ${
                      generalSetting.background_color === 'transparent' && generalSetting.border_color === 'transparent'
                        ? 'padding: 0;'
                        : 'padding: 10px;'
                    }
                    margin-top : 10px;
                }
                [class^="ot-estimated-shipping-shipping-methods-select-item"] {
                    min-height: 0px !important;
                }
                .ot-estimated-shipping-shipping-methods-select-item:checked + label:before {
                    background-color:${generalSetting.border_color};
                    filter: brightness(0.8);
                }
                .ot-estimated-shipping .timeline-layout--item.with-connect-line::after{
                    background-image: linear-gradient(95deg, ${generalSetting.icon_color}33 0%, ${
  generalSetting.icon_color
}33 50%, ${generalSetting.icon_color}33 100%);
                }
                `;

export const frontendCss = `
  .ot-estimated-shipping {
    margin-top: 0.5rem;
  }

  .ot-estimated-shipping-country-select-box-province {
    margin-left: 2%;
  }

  a.shipping-privacy-href{
    cursor: pointer;
    text-decoration: underline;
  }

  .ot-estimated-shipping-zipcode-submit-btn {
    min-width: fit-content;
  }
  
  .ot-estimated-shipping-estimated-text-container {
    width: 100%;
  }
`;
